import React, { useState, useEffect } from 'react'
import '../../styles/common/list.css'

const ListItem = ({
  item,
  isChecked = false,
  onCheck,
  onClick,
  className = '',
  showCheckbox = true,
  columnWidths = null,
}) => {
  const [checked, setChecked] = useState(isChecked)

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  const handleCheckboxClick = (e) => {
    e.stopPropagation()
    const newChecked = !checked
    setChecked(newChecked)

    if (onCheck) {
      onCheck(newChecked)
    }
  }

  const handleItemClick = () => {
    if (onClick) {
      onClick()
    }
  }

  const isSelected = item._isSelected
  const itemClassName = `list-item ${className} ${onClick ? 'clickable' : ''} ${isSelected ? 'selected' : ''}`

  return (
    <div
      className={itemClassName}
      onClick={handleItemClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {showCheckbox && (
        <div
          className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: '60px' } : {}}
        >
          <input
            type="checkbox"
            checked={checked}
            onChange={handleCheckboxClick}
            className="patrol-list-checkbox-input"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
      {Object.entries(item).map(([key, value], index) => {
        if (key.startsWith('_')) return null
        return (
          <div
            key={index}
            className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
            style={columnWidths ? { width: columnWidths[index] } : {}}
          >
            {value}
          </div>
        )
      })}
    </div>
  )
}

export default ListItem
